// extracted by mini-css-extract-plugin
export var content = "_nn-1";
export var fullScreen = "_nn-0";